export const TIERS = [
  { key: "free", name: "Free", price: "$0", coins: 3, lookup: null, perk: "Basic template" },
  { key: "starter", name: "Starter", price: "$10", coins: 100, lookup: "starter_monthly", perk: "+ Modern template" },
  { key: "pro", name: "Pro", price: "$30", coins: 300, lookup: "pro_monthly", perk: "+ Premium template" },
  { key: "heavy", name: "Heavy", price: "$70", coins: 800, lookup: "heavy_monthly", perk: "+ Signature template" },
];

export const TOPUPS = [
  { lookup: "topup_20", coins: 20, price: "$10" },
  { lookup: "topup_50", coins: 50, price: "$25" },
  { lookup: "topup_100", coins: 100, price: "$50" },
];

export const LEAD_PACKS = [
  { lookup: "leads_1", label: "1 Search Coin", price: "$10", sub: "7 leads · $1.43/lead" },
  { lookup: "leads_5", label: "5-Coin Pack", price: "$40", sub: "35 leads · $1.14/lead" },
  { lookup: "leads_15", label: "15-Coin Pack", price: "$100", sub: "105 leads · $0.95/lead" },
];
